// extracted by mini-css-extract-plugin
export default {"header":"styles_header__loKuT","content":"styles_content__4F6A2","footer":"styles_footer__rvB0i"};